const IMAGES = {
    "ArmLeft": require("./ArmLeft.png"),
    "ArmRight": require("./ArmRight.png"),
    "Bug": require("./Bug.png"),
    "EyeUp": require("./EyeUp.png"),
    "Frown": require("./Frown.png"),
    "Grass": require("./Grass.png"),
    "Plant": require("./Plant.png"),
    "PomPom": require("./PomPom.png"),

    "WinScreen": require("./WinScreen.png"),
    "LoseScreen": require("./LoseScreen.png"),
};

export default IMAGES;